import Reveal from "./Reveal";
import { ABOUT_CARDS } from "@/data/content";

const About = () => (
  <section id="about" data-testid="about-section" className="py-20 md:py-28 bg-sky-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center max-w-3xl mx-auto">
        <span className="text-sm font-bold uppercase tracking-wider text-primary">About Us</span>
        <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-foreground leading-tight">
          Trusted Medical Courier <span className="text-primary">Services You Can Count On</span>
        </h2>
      </Reveal>

      <div className="mt-12 md:mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {ABOUT_CARDS.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.06}>
            <div className="h-full rounded-2xl bg-primary p-6 md:p-7 shadow-lg shadow-primary/20 hover:-translate-y-1 transition-transform duration-300">
              <span className="block w-10 h-1 rounded-full bg-white/40 mb-4" />
              <h3 className="text-lg font-bold text-white mb-3">{c.title}</h3>
              <p className="text-sm leading-relaxed text-blue-50/90">{c.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default About;
